"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Center = /** @class */ (function (_super) {
    __extends(Center, _super);
    function Center(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            style: {
                display: "flex",
                alignItems: props.vertical ? "center" : "unset",
                justifyContent: props.horizontal ? "center" : "unset",
                height: "100%"
            }
        };
        return _this;
    }
    Center.prototype.render = function () {
        return (React.createElement("div", { style: this.state.style }, this.props.children));
    };
    return Center;
}(React.Component));
exports.Center = Center;
//# sourceMappingURL=Center.js.map